enum WarehouseLoanTransactionAbasActionsEnum {
    AbasAdd = 'WAREHOUSE_LOAN_TRANSACTION_ABAS/ABASADD',
    AbasList = 'WAREHOUSE_LOAN_TRANSACTION_ABAS/ABAS_LIST',
    AbasSet = 'WAREHOUSE_LOAN_TRANSACTION_ABAS/ABAS_SET',

    AbaGet = 'WAREHOUSE_LOAN_TRANSACTION_ABAS/ABA_GET',
    AbaHistoriesList = 'WAREHOUSE_LOAN_TRANSACTION_ABAS/ABA_HISTORIES_LIST',
    AbaHistoriesSet = 'WAREHOUSE_LOAN_TRANSACTION_ABAS/ABA_HISTORIES_SET',
    AbaSet = 'WAREHOUSE_LOAN_TRANSACTION_ABAS/ABA_SET',
    AbaTransactionsList = 'WAREHOUSE_LOAN_TRANSACTION_ABAS/ABA_TRANSACTIONS_LIST',
    AbaTransactionsSet = 'WAREHOUSE_LOAN_TRANSACTION_ABAS/ABA_TRANSACTIONS_SET',

    UnallocatedTransactionsList = 'WAREHOUSE_LOAN_TRANSACTION_ABAS/UNALLOCATED_TRANSACTIONS_LIST',
    UnallocatedTransactionsSet = 'WAREHOUSE_LOAN_TRANSACTION_ABAS/UNALLOCATED_TRANSACTIONS_SET',
}

export default WarehouseLoanTransactionAbasActionsEnum;
